import { useEffect, useState } from "react";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup"
import { getLocation } from "../../../services/Location";
import { delete_comment, getCommentsReportByAttributeAndAttributeId, getStatus, post_comment } from "../../../services/Appointment";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomSearchableDropdown } from "../../../components/CustomSearchableDropdown";
import { baseURL } from "../../../config/api";
import { validateMin } from "../../../utils/validateMin";
import { CustomDateField } from "../../../components/CustomDateField";
import useConfirm from "../../../hook/useConfirm";
import axios from "axios";
import useAuth from "../../../hook/useAuth";
import { getStatusColor } from "../../../utils/functionHelper";
import AddComments from "./AddComments";
import useDelete from "../../../hook/useDelete";
import { formatUSPhone } from "../../../utils/phoneFormatter";
import { categories } from "../../../utils/categoryType";

type CommentType = {
    id: number;
    attributeName: string;
    attributeId: string;
    notes: string;
    userName: string;
    createdDate: string;
};


export const CreatePurchaseOrder = () => {
    const reorderData = useLocation();
    const { auth }: any = useAuth();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const { locationID, inventoryID, reorderFrom } = reorderData?.state || {};
    const [locationId, setLocationId] = useState<number>(0);
    const [selectedCategory, setSelectedCategory] = useState<number>(1);
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [selectedStatus, setSelectedStatus] = useState<number>(0);
    const [statusOptions, setStatusOptions] = useState<any[]>([]);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [vendorLoadingMore, setVendorLoadingMore] = useState(false);
    const [vendorPage, setVendorPage] = useState(1);
    const [vendorHasMore, setVendorHasMore] = useState(true);
    const [vendorInitialLoading, setVendorInitialLoading] = useState(false);
    const [vendorResults, setVendorResults] = useState<any[]>([]);
    const [vendorLabel, setVendorLabel] = useState<string>("");
    const [vendorSearchQuery, setVendorSearchQuery] = useState<string>("");
    const [vendorId, setVendorId] = useState<number | null>(null);
    const [vendorDataIsLoaded, setVendorDataIsLoaded] = useState<boolean>(true);
    const [vendorDetails, setVendorDetails] = useState<any>({});
    const [allVendorsOfReOrderItem, setAllVendorsOfReOrderItem] = useState<any[]>([]);
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [saveCommentsValue, setSaveCommentsValue] = useState([]);
    const [isComment, setIsComment] = useState(0);
    const [comments, setComments] = useState<string>("");

    useEffect(() => {
        if (locationID && inventoryID && reorderFrom) {
            if (reorderFrom === "Tire") {
                axios
                    .get(`${baseURL}tireInventoryVendorMappings/GetTireInventoryVendorMappingsByInventoryId/${inventoryID}`)
                    .then(async (response) => {
                        const allVendorsResponse = response?.data?.map((vendor: any) =>
                            axios.get(`${baseURL}vendors/${vendor?.vendorId}`)
                        );

                        const vendorsData = (await Promise.all(allVendorsResponse)).map(
                            (res) => res.data
                        );

                        setVendorId(vendorsData[0]?.vendorId);
                        setAllVendorsOfReOrderItem(() => vendorsData?.map((item: any) => {
                            return {
                                value: item?.vendorId,
                                label: item?.vendorName
                            }
                        }))


                        setLocationId(locationID);
                        setSelectedCategory(1);
                        setPleaseWaitPopup(false);
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            }
            else {
                axios
                    .get(`${baseURL}wheelInventoryVendorMappings/GetWheelInventoryVendorMappingsByInventoryId/${inventoryID}`)
                    .then(async (response) => {
                        const allVendorsResponse = response?.data?.map((vendor: any) =>
                            axios.get(`${baseURL}vendors/${vendor?.vendorId}`)
                        );

                        const vendorsData = (await Promise.all(allVendorsResponse)).map(
                            (res) => res.data
                        );

                        setVendorId(vendorsData[0]?.vendorId);
                        setAllVendorsOfReOrderItem(() => vendorsData?.map((item: any) => {
                            return {
                                value: item?.vendorId,
                                label: item?.vendorName
                            }
                        }))


                        setLocationId(locationID);
                        setSelectedCategory(2);
                        setPleaseWaitPopup(false);

                    })
                    .catch((error) => {
                        console.error(error)
                    })
            }

        }
    }, [locationID, inventoryID, reorderFrom])

    useEffect(() => {
        getLocation()
            .then((data) => {
                setLocationOptions(() => data?.map((loc: any) => {
                    return {
                        value: loc?.id,
                        label: loc?.locationName,
                        street: loc?.street,
                        street2: loc?.street2 ? loc?.street2 : null,
                        city: loc?.city,
                        state: loc?.state,
                        zipCode: loc?.zipCode,
                        country: loc?.country,
                        billToCity: loc?.billToCity ? loc?.billToCity : "",
                        billToCountry: loc?.billToCountry ? loc?.billToCountry : "",
                        billToState: loc?.billToState ? loc?.billToState : "",
                        billToStreet: loc?.billToStreet ? loc?.billToStreet : "",
                        billToStreet2: loc?.billToStreet2 ? loc?.billToStreet2 : "",
                        billToZip: loc?.billToZip ? loc?.billToZip : ""
                    }
                }))

                if (!locationID) {
                    setLocationId(data[0]?.id)
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }, [locationID])


    useEffect(() => {
        getStatus("PurchaseOrder")
            .then((data) => {
                setStatusOptions(() => data?.map((status: any) => {
                    return {
                        value: status?.statusID,
                        label: status?.statusValue
                    }
                }))
                setSelectedStatus(data?.find((status: any) => status?.statusValue === "InProgress")?.statusID);
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])

    useEffect(() => {
        if (vendorId && vendorId > 0) {
            setVendorDataIsLoaded(false);
            axios
                .get(`${baseURL}vendors/GetVendorReport/${vendorId}`)
                .then((response) => {
                    setVendorDetails(response?.data);
                    setVendorDataIsLoaded(true);
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }, [vendorId])

    useEffect(() => {
        if (vendorId && vendorId > 0) {
            getCommentsReportByAttributeAndAttributeId("Vendor", vendorId)
                .then(data => {
                    setSaveCommentsValue(data)
                })
                .catch(error => {
                    console.error(error);
                });

        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isComment, vendorId]);


    const vendorFetchData = async (
        pageToLoad: number,
        isFresh = false,
        mode: "default" | "search" = "default"
    ) => {
        if (reorderFrom === "Tire" || reorderFrom === "Wheel") return
        if (vendorLoadingMore) return;
        if (!vendorHasMore && !isFresh) return;
        if (isFresh) {
            setVendorInitialLoading(true);
            setVendorHasMore(true);
        } else {
            setVendorLoadingMore(true);
        }

        const isSearch = mode === "search";
        const pageSize = 10;

        const api = isSearch
            ? locationId ? `${baseURL}vendors/GetVendorsReportByLocationIdAndSearchWithVendorName?locationId=${locationId}&vendorName=${vendorSearchQuery.trim()
                }&page=${pageToLoad}&size=${pageSize}`
                : `${baseURL}vendors/GetVendorsReportSearchWithVendorName?vendorName=${vendorSearchQuery.trim()}&page=${pageToLoad}&size=${pageSize}`
            : locationId ? `${baseURL}vendors/GetVendorReportPagingByLocationId/${locationId},${pageToLoad},${pageSize}` : `${baseURL}vendors/GetVendorReportPaging/${pageToLoad},${pageSize}`;

        try {
            const res = await fetch(api);

            if (!res.ok) {
                throw new Error("Failed to fetch events");
            }

            const data = await res.json();
            const list = data?.vendors?.map((item: any) => {
                return {
                    value: item?.vendorId,
                    label: item?.vendorName
                }
            }) || [];

            setVendorResults(prev =>
                pageToLoad === 0 ? list : [...prev, ...list]
            );

            setVendorHasMore(list.length === pageSize);
            setVendorPage(pageToLoad + 1);
        } catch (err) {
            console.error("Fetch events error:", err);
        } finally {
            setVendorLoadingMore(false);
            setVendorInitialLoading(false);
        }
    };



    const saveComments = () => {
        if (!comments?.trim()) {
            return;
        }
        setPleaseWaitPopup(true);

        post_comment(
            {
                attributeName: "Vendor",
                attributeId: vendorId,
                notes: comments,
                userId: auth?.id,
                createdDate: new Date().toLocaleString(),
            }, auth?.id)
            .then(() => {
                setComments("");
                setIsComment(isComment + 1);
                setPleaseWaitPopup(false);

            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error(error)
            });
    };

    const deleteTheComment = async (id: number) => {
        setDeleteData({
            id: id,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this comment?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);
                callback();
                delete_comment(id, auth?.id)
                    .then(() => {
                        setSaveCommentsValue(saveCommentsValue.filter((item: any) => item.id !== id))
                        setPleaseWaitPopup(false);

                    })
                    .catch((error) => {
                        console.error(error)
                    });
            }
        });
        setDeletePopup(true);
    }


    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <div className="flex items-center justify-between py-2">
                        <h2 className={`text-lg font-semibold`}>Create Purchase Order</h2>
                        <div className="flex items-center gap-1.5">
                            <div>
                                <select
                                    value={selectedCategory}
                                    onChange={(e) => setSelectedCategory(Number(e.target.value))}
                                    className="w-[100px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                                >
                                    {categories.map((category: any, index: number) => (
                                        <option key={index} value={category?.id}>
                                            {category?.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {
                                (!reorderFrom) && (
                                    <div>
                                        <select
                                            value={locationId}
                                            onChange={(e) => {
                                                setLocationId(Number(e.target.value))
                                                setVendorId(null);
                                                setVendorPage(1)
                                                setVendorHasMore(true);
                                                setVendorResults([]);
                                                setVendorSearchQuery("");
                                                setVendorLabel("");
                                            }}
                                            className="w-[200px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                                        >
                                            {locationOptions.map((loc: any, index: number) => (
                                                <option key={index} value={loc?.value}>
                                                    {loc?.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                            <div>
                                <div>
                                    <select
                                        value={selectedStatus}
                                        onChange={(e) => {
                                            setSelectedStatus(Number(e.target.value))

                                        }}
                                        className="w-[120px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                                    >
                                        {statusOptions.map((status: any, index: number) => (
                                            <option key={index} value={status?.value}>
                                                {status?.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-between mt-2 p-2">
                        <div className="w-[65%] space-y-4">
                            <InventoryView
                                locationId={locationId}
                                selectedVendorId={vendorId}
                                selectedCategory={selectedCategory}
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                                inventoryID={inventoryID ? inventoryID : null}

                            />

                            <SelectedInventoryView
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                            />

                            <ShipmentView
                                locationOptions={locationOptions}
                                selectedItems={selectedItems}
                                setPleaseWaitPopup={setPleaseWaitPopup}
                                selectedVendorId={vendorId}
                                selectedStatus={selectedStatus}
                                locationId={locationId}
                                selectedCategory={selectedCategory}
                            />
                        </div>

                        <div className="w-[30%] space-y-4">
                            {
                                (!reorderFrom) && (
                                    <CustomSearchableDropdown
                                        label="Vendors"
                                        value={vendorId}
                                        setValue={setVendorId}
                                        selectedOptionLabel={vendorLabel}
                                        setSelectedOptionLabel={setVendorLabel}
                                        placeholder="Search Vendor"
                                        onDemandData={true}
                                        setResults={setVendorResults}
                                        results={vendorResults}
                                        fetchData={vendorFetchData}
                                        setSearchQuery={setVendorSearchQuery}
                                        searchQuery={vendorSearchQuery}
                                        initialLoading={vendorInitialLoading}
                                        loadingMore={vendorLoadingMore}
                                        page={vendorPage}
                                        setPage={setVendorPage}
                                        hasMore={vendorHasMore}
                                        setHasMore={setVendorHasMore}
                                    />

                                )}
                            {
                                (reorderFrom === "Tire" || reorderFrom === "Wheel") && (
                                    <CustomSearchableDropdown
                                        label={`Vendor`}
                                        options={allVendorsOfReOrderItem}
                                        value={vendorId}
                                        setValue={setVendorId}
                                        onChange={setVendorId}
                                        placeholder="Search Vendor"
                                        selectedOptionLabel={vendorId ? String(allVendorsOfReOrderItem?.find((item: any) => item?.value === vendorId)?.label) : ""}
                                        labelClassNameProp={"text-sm text-gray-700 flex justify-between"}
                                    />
                                )
                            }
                            {
                                !vendorDataIsLoaded && (
                                    <div className="flex flex-col items-center rounded-lg bg-white px-6 py-8 shadow-sm">
                                        <div className="mb-4 h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                    </div>
                                )
                            }

                            {
                                (vendorId !== null && vendorId > 0 && vendorDetails && vendorDataIsLoaded) && (
                                    <div className="w-full bg-white shadow-sm rounded-2xl p-6 border border-gray-100">

                                        {/* Header */}
                                        <div className="flex items-center justify-between mb-6 border-b pb-2">
                                            <h2 className="text-sm font-semibold text-gray-800">
                                                Vendor Status
                                            </h2>
                                            {vendorDetails?.statusName && (() => {
                                                const color = getStatusColor(vendorDetails?.statusName);

                                                return (
                                                    <div className="flex items-end h-full">
                                                        <span
                                                            className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}
                                                        >
                                                            {vendorDetails?.statusName}
                                                        </span>
                                                    </div>
                                                );
                                            })()}
                                        </div>

                                        {/* Contacts Section */}
                                        <div className="w-full space-y-2">

                                            {/* Contact Person 1 */}
                                            <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                <h3 className="text-sm font-medium text-gray-500">
                                                    Contact Person 1
                                                </h3>
                                                <p className="text-sm font-semibold text-gray-800">
                                                    {vendorDetails?.contactPerson1}
                                                </p>
                                                <p className="text-sm text-gray-600 mt-1">
                                                    📞 {formatUSPhone(vendorDetails?.contactPerson1Phone)}
                                                </p>
                                            </div>

                                            {/* Contact Person 2 */}
                                            {vendorDetails?.contactPerson2 && (
                                                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                    <h3 className="text-sm font-medium text-gray-500">
                                                        Contact Person 2
                                                    </h3>
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {vendorDetails?.contactPerson2}
                                                    </p>
                                                    <p className="text-sm text-gray-600 mt-1">
                                                        📞 {formatUSPhone(vendorDetails?.contactPerson2Phone)}
                                                    </p>
                                                </div>
                                            )}

                                            {vendorDetails?.email && (
                                                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                    <h3 className="text-sm font-medium text-gray-500">
                                                        Email
                                                    </h3>
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {vendorDetails?.email}
                                                    </p>

                                                </div>
                                            )}

                                            {vendorDetails?.fax && (
                                                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                    <h3 className="text-sm font-medium text-gray-500">
                                                        FAX
                                                    </h3>
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {vendorDetails?.fax}
                                                    </p>

                                                </div>
                                            )}

                                            {vendorDetails?.website && (
                                                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                    <h3 className="text-sm font-medium text-gray-500">
                                                        Website
                                                    </h3>
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {vendorDetails?.website}
                                                    </p>

                                                </div>
                                            )}


                                            <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                <h3 className="text-sm font-medium text-gray-500">
                                                    Address
                                                </h3>
                                                <p className="text-sm text-gray-800">
                                                    {vendorDetails?.address1}, {vendorDetails?.address2}, {vendorDetails?.city}, {vendorDetails?.state}, {vendorDetails?.county}, {vendorDetails?.zipCode}, {vendorDetails?.country}
                                                </p>

                                            </div>

                                            <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2">
                                                <h3 className="text-sm font-medium text-gray-500">
                                                    Delivery Time
                                                </h3>
                                                <p className="text-sm text-gray-800">
                                                    {vendorDetails?.deliveryTime}
                                                </p>

                                            </div>


                                        </div>
                                    </div>
                                )
                            }

                            {
                                (vendorId !== null && vendorId > 0) && (
                                    <div className="w-full px-2">

                                        <div className="mt-[16px]">
                                            <div className="flex items-center justify-between">
                                                <span className={`text-xs font-medium`}>Comments</span>

                                            </div>

                                            {
                                                saveCommentsValue && (
                                                    <div className="mt-[16px]">
                                                        {
                                                            saveCommentsValue.map((item: CommentType) => {
                                                                return (
                                                                    <AddComments
                                                                        id={item.id}
                                                                        userName={item.userName}
                                                                        createdDate={item.createdDate}
                                                                        notes={item.notes}
                                                                        deleteTheComment={(id) => deleteTheComment(id)}
                                                                    />
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                )
                                            }

                                            <div className="mt-[16px]">
                                                <textarea
                                                    className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                    rows={6}
                                                    value={comments}
                                                    onChange={(e) => setComments(e.target.value)}
                                                />
                                                <div className="mt-6">
                                                    <button
                                                        type="button"
                                                        onClick={() => saveComments()}
                                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                                    >
                                                        Save
                                                    </button>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}


type InventoryViewProps = {
    locationId: number;
    selectedVendorId: number | null;
    selectedCategory: number;
    selectedItems: any[];
    setSelectedItems: (value: any) => void
    inventoryID: number | null
}

const InventoryView = ({
    locationId,
    selectedVendorId,
    selectedCategory,
    selectedItems,
    setSelectedItems,
    inventoryID
}: InventoryViewProps) => {
    const [inventories, setInventories] = useState<any[]>([]);
    const [filterInventories, setFilterInventories] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (selectedVendorId && selectedVendorId > 0) {
            if (locationId > 0) {
                if (selectedCategory === 1) {
                    setLoading(true);
                    setInventories([]);
                    setFilterInventories([]);
                    fetch(`${baseURL}tireInventories/GetTireInventoriesReportByLocationIdAndByVendorId/${selectedVendorId},${locationId}`)
                        .then((res) => res.json())
                        .then((data) => {
                            const result = data?.map((item: any) => {
                                return {
                                    ...item,
                                    id: item?.inventoryId,
                                    isReorder: item?.quantityOnHand <= item?.reorderLevel ? true : false,
                                    isCheck: inventoryID ? item?.inventoryId === Number(inventoryID) ? true : false : false
                                };
                            })

                            setInventories(result);
                            setLoading(false);
                        })
                        .catch(error => {
                            setInventories([]);
                            setLoading(false);
                            console.error(error);
                        });
                }
                else {
                    setInventories([]);
                    setFilterInventories([]);
                    setLoading(true);
                    fetch(`${baseURL}wheelInventories/GetWheelInventoriesReportByLocationIdAndByVendorId/${selectedVendorId},${locationId}`)
                        .then((res) => res.json())
                        .then((data) => {
                            const result = data?.map((item: any) => {
                                return {
                                    ...item,
                                    id: item?.inventoryId,
                                    isReorder: item?.quantityOnHand <= item?.reorderLevel ? true : false,
                                    isCheck: inventoryID ? item?.inventoryId === Number(inventoryID) ? true : false : false
                                };
                            })

                            setInventories(result);
                            setLoading(false);
                        })
                        .catch(error => {
                            setInventories([]);
                            setLoading(false);
                            console.error(error);
                        });
                }
            }
            else {
                if (selectedCategory === 1) {
                    setInventories([]);
                    setFilterInventories([]);
                    setLoading(true);
                    fetch(`${baseURL}tireInventories/GetTireInventoriesReportByVendorId/${selectedVendorId}`)
                        .then((res) => res.json())
                        .then((data) => {
                            const result = data?.map((item: any) => {
                                return {
                                    ...item,
                                    id: item?.inventoryId,
                                    isReorder: item?.quantityOnHand <= item?.reorderLevel ? true : false,
                                    isCheck: inventoryID ? item?.inventoryId === Number(inventoryID) ? true : false : false
                                };
                            })

                            setInventories(result);
                            setLoading(false);
                        })
                        .catch(error => {
                            setInventories([]);
                            setLoading(false);
                            console.error(error);
                        });
                }
                else {
                    setInventories([]);
                    setFilterInventories([]);
                    setLoading(true);
                    fetch(`${baseURL}wheelInventories/GetWheelInventoriesReportByVendorId/${selectedVendorId}`)
                        .then((res) => res.json())
                        .then((data) => {
                            const result = data?.map((item: any) => {
                                return {
                                    ...item,
                                    id: item?.inventoryId,
                                    isReorder: item?.quantityOnHand <= item?.reorderLevel ? true : false,
                                    isCheck: inventoryID ? item?.inventoryId === Number(inventoryID) ? true : false : false
                                };
                            })

                            setInventories(result);
                            setLoading(false);
                        })
                        .catch(error => {
                            setInventories([]);
                            setLoading(false);
                            console.error(error);
                        });
                }
            }

        }
        else {
            setInventories([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationId, selectedVendorId, inventoryID, selectedCategory])

    useEffect(() => {
        const search = searchValue.toLowerCase()?.trim()
        if (search === "") {
            setFilterInventories(inventories)
            setSelectedItems(inventories.filter((item: any) => item?.isCheck).map((item: any) => ({
                ...item,
                qtyOrdered: 0,
            })))
        }
        else {
            setFilterInventories(() =>
                inventories.filter((item: any) => item?.sku?.toLowerCase()?.includes(search) || item?.modelName?.toLowerCase()?.includes(search) || item?.brandName?.toLowerCase()?.includes(search))
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inventories, searchValue])



    const handleItemOnChecked = (id: number) => {

        const updatedInventories = filterInventories.map((item: any) => {
            if (item.id === id) {
                return {
                    ...item,
                    isCheck: !item.isCheck,
                };
            }
            return item;
        });

        setFilterInventories(updatedInventories);

        const clickedItem = updatedInventories.find((item: any) => item.id === id);

        if (!clickedItem) return;

        setSelectedItems((prev: any) => {

            // If checked → ADD
            if (clickedItem.isCheck) {
                const alreadyExists = prev.some((item: any) => item.id === id);

                if (alreadyExists) return prev;

                return [
                    ...prev,
                    {
                        ...clickedItem,
                        qtyOrdered: 0
                    }
                ];
            }

            // If unchecked → REMOVE
            return prev.filter((item: any) => item.id !== id);
        });
    };

    return (
        <section className="border border-gray-200 rounded-xl bg-white shadow-sm">
            {/* Header */}
            <div className="flex justify-between items-center px-4 py-3 border-b bg-gradient-to-r from-gray-50 to-white rounded-t-xl">
                <span className="font-semibold text-lg text-gray-800">Vendor Items</span>

                <input
                    className="bg-gray-100 focus:bg-white border border-gray-200 focus:border-primary px-3 py-1.5 rounded-full text-sm text-gray-700 placeholder:text-gray-400 outline-none transition-all duration-200 shadow-sm focus:shadow"
                    placeholder="Search..."
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div>

            {/* Table Container */}
            <div className="h-64 overflow-y-auto mt-2">
                <table className="w-full text-sm">
                    {/* Header */}
                    <thead className="sticky top-0 z-10 bg-gray-100 shadow-sm whitespace-nowrap">
                        <tr>
                            <th className="px-4 py-3 text-left font-semibold text-gray-700"></th>
                            {[
                                "Item No.",
                                "Model Name",
                                "Brand Name",
                                "In Stock",
                                "Reorder Level",
                                "Reorder Quantity",
                                "PricePer",
                            ].map((item, index) => (
                                <th
                                    key={index}
                                    className="px-4 py-3 text-left font-semibold text-gray-700"
                                >
                                    {item}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    {/* Body */}
                    <tbody className="divide-y">
                        {filterInventories?.map((item, index) => (
                            <tr
                                key={index}
                                className={`transition-colors duration-150  ${item?.isReorder ? "bg-red-300 border-l-4 border-red-500 hover:bg-red-300" : "hover:bg-gray-50"} `}
                                onClick={() => handleItemOnChecked(item.id)}
                            >
                                <td className="px-4 py-3">
                                    <input
                                        type="checkbox"
                                        checked={item?.isCheck}
                                        className="w-4 h-4 accent-primary cursor-pointer"
                                        onChange={() => handleItemOnChecked(item.id)}
                                    />
                                </td>

                                <td className="px-4 py-3 font-medium text-gray-800">
                                    {item?.sku}
                                </td>
                                <td className="px-4 py-3 text-gray-700">{item?.modelName}</td>
                                <td className="px-4 py-3 text-gray-700">{item?.brandName}</td>
                                <td className="px-4 py-3 text-gray-700">{item?.quantityOnHand}</td>
                                <td className="px-4 py-3 text-gray-700">{item?.reorderLevel}</td>
                                <td className="px-4 py-3 text-gray-700">{item?.reorderQuantity}</td>
                                <td className="px-4 py-3 text-gray-700">{item?.costPrice}</td>
                            </tr>
                        ))}

                        {loading && (
                            <tr>
                                <td colSpan={10} className="text-center py-6 text-gray-500">
                                    Loading...
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </section>

    );
};

type SelectedInventoryViewProps = {
    selectedItems: any[];
    setSelectedItems: (value: any[]) => void
}

const SelectedInventoryView = ({
    selectedItems,
    setSelectedItems
}: SelectedInventoryViewProps) => {
    const [filterSelectedItems, setFilterSelectedItems] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");

    useEffect(() => {
        const search = searchValue.toLowerCase()?.trim()
        if (search === "") {
            setFilterSelectedItems(selectedItems)
        }
        else {
            setFilterSelectedItems(() =>
                selectedItems.filter((item: any) => item?.sku?.toLowerCase()?.includes(search) || item?.modelName?.toLowerCase()?.includes(search))
            )
        }
    }, [selectedItems, searchValue])


    return (
        <section className="border border-gray-200 rounded-xl bg-white shadow-sm">
            {/* Header */}
            <div className="flex justify-between items-center px-4 py-3 border-b bg-gradient-to-r from-gray-50 to-white rounded-t-xl">
                <span className="font-semibold text-lg text-gray-800">Selected Items</span>

                <input
                    className="bg-gray-100 focus:bg-white border border-gray-200 focus:border-primary px-3 py-1.5 rounded-full text-sm text-gray-700 placeholder:text-gray-400 outline-none transition-all duration-200 shadow-sm focus:shadow"
                    placeholder="Search..."
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div>

            {/* Table Container */}
            <div className="h-64 overflow-y-auto mt-2">
                <table className="w-full text-sm">
                    {/* Header */}
                    <thead className="sticky top-0 z-10 bg-gray-100 shadow-sm whitespace-nowrap">
                        <tr>
                            {[
                                "#",
                                "Item No.",
                                "Model Name",
                                "Quantity Ordered",
                                "Cost",
                            ].map((item, index) => (
                                <th
                                    key={index}
                                    className="px-4 py-3 text-left font-semibold text-gray-700"
                                >
                                    {item}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    {/* Body */}
                    <tbody className="divide-y">
                        {filterSelectedItems?.map((item, index) => (
                            <tr
                                key={index}
                                className={`transition-colors duration-150 hover:bg-gray-50`}
                            //onClick={() => handleItemOnChecked(item.id)}
                            >
                                <td className="px-4 py-3 font-medium text-gray-800">
                                    {index + 1}
                                </td>
                                <td className="px-4 py-3 font-medium text-gray-800">
                                    {item.sku}
                                </td>
                                <td className="px-4 py-3 font-medium text-gray-800">{item.modelName}</td>
                                <td className="px-4 py-3  font-medium text-gray-800">
                                    <input
                                        className="outline-none rounded-md p-2 border border-gray-400 bg-gray-50 focus:bg-white focus:border-primary"
                                        min={0}
                                        type="number"
                                        value={item.qtyOrdered}
                                        onChange={(e) => {
                                            let qnty = validateMin(e.target.value, 0)
                                            setSelectedItems(
                                                selectedItems.map((_: any, i: number) =>
                                                    i === index ? { ..._, qtyOrdered: qnty } : _
                                                )
                                            );
                                        }}
                                    />
                                </td>
                                <td className="px-4 py-3  font-medium text-gray-800">{item.costPrice}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    )
}

type ShipmentViewProps = {
    locationOptions: any[]
    selectedItems: any[]
    setPleaseWaitPopup: (value: boolean) => void
    selectedVendorId: null | number
    selectedStatus: number
    locationId: number
    selectedCategory: number
}
const ShipmentView = ({ locationOptions, selectedItems, setPleaseWaitPopup, selectedVendorId, selectedStatus, locationId, selectedCategory }: ShipmentViewProps) => {
    const { auth }: any = useAuth();
    const navigate = useNavigate();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [expanded, setExpanded] = useState<boolean>(false);
    const [shipVia, setShipVia] = useState<string>("");
    const [shipToStreet, setShipToStreet] = useState<string>("");
    const [shipToStreet2, setShipToStreet2] = useState<string>("");
    const [shipToCity, setShipToCity] = useState<string>("");
    const [shipToState, setShipToState] = useState<string>("");
    const [shipToCountry, setShipToCountry] = useState<string>("");
    const [shipToZip, setShipToZip] = useState<string>("");
    const [billToStreet, setBillToStreet] = useState<string>("");
    const [billToStreet2, setBillToStreet2] = useState<string>("");
    const [billToCity, setBillToCity] = useState<string>("");
    const [billToState, setBillToState] = useState<string>("");
    const [billToCountry, setBillToCountry] = useState<string>("");
    const [billToZip, setBillToZip] = useState<string>("");
    const [reference, setReference] = useState<string>("");
    const [dueDate, setDueDate] = useState<string>("");
    const [instructions, setInstructions] = useState<string>("");
    const [orderReason, setOrderReason] = useState<string>("");
    const [isCopiedShippingAddress, setIsCopiedShippingAddress] = useState<boolean>(false);

    useEffect(() => {
        if (locationOptions.length > 0) {
            const locationDetails = locationOptions?.find((loc: any) => loc?.value === locationId)
            setShipToStreet(locationDetails?.street);
            setShipToStreet2(locationDetails?.street2);
            setShipToCity(locationDetails?.city);
            setShipToState(locationDetails?.state);
            setShipToCountry(locationDetails?.country);
            setShipToZip(locationDetails?.zipCode);
            setBillToStreet(locationDetails?.billToStreet);
            setBillToStreet2(locationDetails?.billToStreet2);
            setBillToCity(locationDetails?.billToCity);
            setBillToState(locationDetails?.billToState);
            setBillToCountry(locationDetails?.billToCountry);
            setBillToZip(locationDetails?.billToZip);
            setIsCopiedShippingAddress(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationId])

    useEffect(() => {
        if (isCopiedShippingAddress) {
            setBillToStreet(shipToStreet);
            setBillToStreet2(shipToStreet2);
            setBillToCity(shipToCity);
            setBillToState(shipToState);
            setBillToCountry(shipToCountry);
            setBillToZip(shipToZip);
        }
        else {
            setBillToStreet("");
            setBillToStreet2("");
            setBillToCity("");
            setBillToState("");
            setBillToCountry("");
            setBillToZip("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCopiedShippingAddress])

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (selectedItems?.length > 0) {
            if (!expanded) {
                if (
                    shipVia !== "" &&
                    shipToStreet !== "" &&
                    shipToCity !== "" &&
                    shipToState !== "" &&
                    shipToCountry !== "" &&
                    shipToZip !== "" &&
                    billToStreet !== "" &&
                    billToCity !== "" &&
                    billToState !== "" &&
                    billToCountry !== "" &&
                    billToZip !== "" &&
                    dueDate !== ""
                ) {
                    setConfirmPopup(true);
                    setConfirmData({
                        title: "Are you sure you want to create the purchase order?",
                        confirmBtn: "Yes",
                        isConfirm: (callback: any) => {
                            saveData(callback)
                        }
                    })

                }
                else {
                    setConfirmPopup(true);
                    setConfirmData({
                        title: "Please fill all the required fields",
                        confirmBtn: "Yes",
                        isConfirm: (callback: any) => {
                            setExpanded(true);
                            callback()
                        }
                    })

                }
            }
            else {
                setConfirmPopup(true);
                setConfirmData({
                    title: "Are you sure you want to create the purchase order?",
                    confirmBtn: "Yes",
                    isConfirm: (callback: any) => {
                        saveData(callback)
                    }
                })
            }
        }
        else {
            setConfirmPopup(true);
            setConfirmData({
                title: "Please add at least one item to create purchase order.",
                confirmBtn: "Yes",
                isConfirm: (callback: any) => {
                    setExpanded(true);
                    callback()
                }
            })
        }
    }

    const saveData = async (callback: any) => {
        setPleaseWaitPopup(true)
        let totalCost = 0;
        let totalCostReceived = 0;

        selectedItems?.forEach((item: any) => {
            totalCost += item.costPrice * item.qtyOrdered;
            totalCostReceived += item.costPrice * item.qtyReceived;
        });

        await axios.post(
            `${baseURL}purchaseOrders?userId=${auth?.id}`,
            JSON.stringify({
                locationId,
                vendorId: selectedVendorId,
                categoryType: selectedCategory,
                reference,
                totalCost,
                totalCostReceived,
                dueDate,
                shipVia,
                shipToStreet,
                shipToStreet2,
                shipToCity,
                shipToState,
                shipToCountry,
                shipToZip,
                billToStreet,
                billToStreet2,
                billToCity,
                billToState,
                billToCountry,
                billToZip,
                instructions,
                statusId: selectedStatus,
                billableDepartment: "",
                orderingMode: "",
                fullyAuthorized: true,
                cancelDate: "",
                totalCharges: 0,
                fullyPaid: true,
                orderReason,
                distributor: "",
                createdAt: new Date().toLocaleString(),
                createdBy: auth?.givenname,
                updatedAt: null,
                updatedBy: null
            }),
            {
                headers: { "Content-Type": "application/json" },
                withCredentials: false,
            }
        )
            .then((res) => {
                createDetails(callback, res?.data?.purchaseOrderId);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });

    }


    const createDetails = async (callback: any, id: number) => {
        try {
            const requests = selectedItems?.map(async (item: any, index: number) =>
                await axios.post(
                    `${baseURL}purchaseOrderDetails?userId=${auth?.id}`,
                    JSON.stringify({
                        locationId,
                        purchaseOrderId: id,
                        itemNum: item.sku,
                        lineNumber: index + 1,
                        quantityOrdered: item.qtyOrdered,
                        costPer: item.costPrice,
                        quantityReceived: 0,
                        vendorPartNumber: "",
                        casePack: 0,
                        currentBatchQuantity: 0,
                        quantityDamaged: 0,
                        reason: "",
                        numberPerCase: 0,
                        overrideCommission: true,
                        quantityOutofDate: 0,
                    }),
                    {
                        headers: { "Content-Type": "application/json" },
                        withCredentials: false,
                    }
                )
            );

            await Promise.all(requests);
            callback();
            setPleaseWaitPopup(false);
            navigate(-1);
        } catch (error) {
            console.error(error);
            callback();
        }
    };


    return (
        <section className="py-2 bg-white border border-gray-200 rounded-xl shadow-sm">
            {/* Header */}
            <div className="flex justify-between items-center px-4 py-3">
                <h5
                    className="flex items-center gap-2 cursor-pointer select-none"
                    onClick={() => setExpanded(!expanded)}
                >
                    <span className="material-symbols-outlined text-[26px] text-gray-600 transition-transform duration-200">
                        {expanded ? "keyboard_arrow_down" : "keyboard_arrow_right"}
                    </span>
                    <span className="font-semibold text-lg text-gray-800">Ship</span>
                </h5>
            </div>

            <div className="px-4">
                <hr className="w-full h-[1px] bg-gray-200" />
            </div>

            <form
                onSubmit={handleSubmit}
                className="w-full rounded-md px-5 py-4 relative">
                {expanded ? (
                    <div className="my-2 text-center">
                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Ship Via
                                </label>
                                <input
                                    name="shipVia"
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipVia}
                                    onChange={(e) => setShipVia(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm flex justify-center items-center">
                                <button
                                    type="button"
                                    className="font-semibold flex items-center gap-2 text-gray-600 hover:text-secondary transition"

                                >
                                    <span>Copy Shipping Address</span>
                                    <input type="checkbox" className="accent-secondary"
                                        checked={isCopiedShippingAddress}
                                        onChange={(e) => setIsCopiedShippingAddress(e.target.checked)}
                                    />
                                </button>
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shipping Street
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToStreet}
                                    onChange={(e) => setShipToStreet(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing Street
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToStreet}
                                    onChange={(e) => setBillToStreet(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shipping Street 2
                                </label>
                                <input
                                    type="text"
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToStreet2}
                                    onChange={(e) => setShipToStreet2(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing Street 2
                                </label>
                                <input
                                    type="text"
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToStreet2}
                                    onChange={(e) => setBillToStreet2(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shipping City
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToCity}
                                    onChange={(e) => setShipToCity(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing City
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToCity}
                                    onChange={(e) => setBillToCity(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shipping State
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToState}
                                    onChange={(e) => setShipToState(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing State
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToState}
                                    onChange={(e) => setBillToState(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shipping Country
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToCountry}
                                    onChange={(e) => setShipToCountry(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing Country
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToCountry}
                                    onChange={(e) => setBillToCountry(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Shiping ZipCode
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={shipToZip}
                                    onChange={(e) => setShipToZip(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Billing ZipCode
                                </label>
                                <input
                                    type="text"
                                    required
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={billToZip}
                                    onChange={(e) => setBillToZip(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Reference #
                                </label>
                                <input
                                    name="reference"
                                    type="text"
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={reference}
                                    onChange={(e) => setReference(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Due Date
                                </label>
                                <CustomDateField
                                    value={dueDate}
                                    onChange={(value) => { setDueDate(value) }}
                                    minDate={new Date().toISOString().split("T")[0]}
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    required={true}
                                />
                            </div>
                        </div>

                        <div className="flex justify-between gap-4 my-4">
                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Instructions
                                </label>
                                <textarea
                                    name="instructions"
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={instructions}
                                    onChange={(e) => setInstructions(e.target.value)}
                                />
                            </div>

                            <div className="w-full text-sm">
                                <label className="block text-xs font-semibold text-gray-600 mb-1">
                                    Order Reason
                                </label>
                                <textarea
                                    name="orderReason"
                                    className="w-full border border-gray-200 bg-gray-50 focus:bg-white focus:border-primary px-3 py-2 rounded-md outline-none transition"
                                    value={orderReason}
                                    onChange={(e) => setOrderReason(e.target.value)}
                                />
                            </div>


                        </div>
                    </div>
                ) : null}

                {/* Buttons */}
                <div className="flex max-sm:flex-col gap-4 mt-6">
                    <button
                        type="submit"
                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                    >
                        Save
                    </button>

                    <button
                        type="button"
                        //onClick={() => navigate(-1)}
                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </section>

    )
}